import { Modal, Text } from '@nimbus-ds/components';
import { CancelAndConfirmButtons } from 'commons/components';
import { useTranslationMarketing } from 'domains/Marketing/hook';

const { Header, Body, Footer } = Modal;

interface DeletePromotionModalProps {
  show: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export function DeletePromotionModal({
  show,
  onClose,
  onDelete,
}: Readonly<DeletePromotionModalProps>) {
  const t = useTranslationMarketing('promotions.deleteModal');

  const handleDelete = () => {
    onDelete();
    onClose();
  };
  return (
    <Modal open={show} onDismiss={onClose}>
      <Header title={t('title')} />
      <Body padding="none">
        <Text>{t('body')}</Text>
      </Body>
      <Footer>
        <CancelAndConfirmButtons
          onCancel={onClose}
          onConfirm={handleDelete}
          cancelText={t('cancel')}
          confirmText={t('confirm')}
          appearance="danger"
        />
      </Footer>
    </Modal>
  );
}
